<app-receivers-select-filters
  [allData]="allFilters"
  [initData]="initFilters"
  (onSelectChanged)="onFiltersChanged($event)"
></app-receivers-select-filters>
<app-search-field [(search)]="searchVal"></app-search-field>
<div class="margin-top-20">
  <app-clickable-row-table
    [data]="tableData"
    [config]="tableConfig"
    [pageIndex]="tabPaginator"
    [headerRef]="tabHeader"
    [search]="searchVal"
  >
    <ng-template #tabHeader let-column="column">
      <ng-container [ngSwitch]="column.value">
        <ng-container *ngSwitchCase="'checkbox'">
          <mat-checkbox
            [checked]="selectableRowCount > 0 && selectedSelectableRowCount === selectableRowCount"
            [indeterminate]="selectedSelectableRowCount > 0 && selectedSelectableRowCount < selectableRowCount"
            [disabled]="selectableRowCount === 0"
            (change)="checkAll($event.checked)"
            color="primary"
          ></mat-checkbox>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="templateService.defaultRowTableHeader; context: { column: column }"> </ng-container>
        </ng-container>
      </ng-container>
    </ng-template>
  </app-clickable-row-table>
</div>
